"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});

var _BottomNavigation = _interopRequireDefault(require("./BottomNavigation"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/BottomNavigation/index.js
// module id = 682
// module chunks = 0